// extracted by mini-css-extract-plugin
export default {"section":"Intro_section__lq1o1","wrap":"Intro_wrap__2fS26","title":"Intro_title__NCZm8","text":"Intro_text__vzwq-","gallery":"Intro_gallery__LI08w","preview":"Intro_preview__YyeGh"};